import React from 'react';
import { Droppable } from './droppable';
import Task from './common/Task';

const PaneTaskList = ({ tasks, isLoading, handleContextMenu, handleDelete, onComplete }) => {
    return (
        <Droppable id="task-pane">
            <div className='overflow-y-auto flex-grow max-h-[calc(100vh-300px)]'>
                {isLoading ? (
                    <p>Loading tasks...</p>
                ) : tasks && tasks?.length > 0 ? (
                    tasks?.map((task) => (
                        <Task
                            key={task?.task_id}
                            task={task}
                            onContextMenu={handleContextMenu}
                            onDelete={() => handleDelete(task?.task_id, 'pane')}
                            onComplete={onComplete}
                            isDraggable={true}
                        />
                    ))
                ) : (
                    <p>No tasks available.</p>
                )}
            </div>
        </Droppable>
    );
};

export default PaneTaskList;